import React, { useEffect, useState, useMemo } from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import { fetchNYUserActivityFunnel } from "../../../api/nystats";
import { useSelector } from "react-redux";


const ActivtiyFunnel = ({ isLoading, funnelData, maxUsers, MonetizationData, platForm, maxMonetization }) => {
  return (
    <Box sx={{ border: "1px solid #E8E8E8", p: 2, borderRadius: "12px", background: "#fff" }}>
      <Typography sx={{
        fontSize: "18px",
        fontWeight: 500,
        color: "#101828",
        mb: 3,
        borderLeft: "3px solid #FBBF24",
        pl: 1,
      }}>
        {platForm} User Funnel
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'stretch', gap: 2 }}>
        <Box sx={{ border: "1px solid #E8E8E8", p: 3, borderRadius: "12px", background: "#fff", width: '100%', }}>
          <Typography sx={{ fontSize: '16px', color: '#101828', fontWeight: 500, mb: 2 }}>Engagement Funnel</Typography>
          {
            isLoading ?
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body1" color="text.secondary">
                  Loading...
                </Typography>
              </Box> :
              funnelData.map((step, index) => {
                const percentage = step.count > 0 ? (step.count / maxUsers) * 100 : 0;
                return (
                  <Box key={index} mb={2}>
                    {/* Label + Number */}
                    <Box display="flex" justifyContent="space-between" mb={1}>
                      <Typography fontSize={14} color="#343A40" fontWeight={500}>
                        {step?.label}
                      </Typography>
                      <Typography fontSize={14} fontWeight={500}>
                        {step?.count?.toLocaleString()}
                      </Typography>
                    </Box>

                    {/* Progress Bar */}
                    <LinearProgress
                      variant="determinate"
                      value={percentage}
                      sx={{
                        height: 12,
                        borderRadius: 5,
                        backgroundColor: "#eee",
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "#FF8676",
                        },
                      }}
                    />
                  </Box>
                );
              })}
        </Box>
        <Box sx={{ border: "1px solid #E8E8E8", p: 3, borderRadius: "12px", background: "#fff", width: '100%', }}>
          <Typography sx={{ fontSize: '16px', color: '#101828', fontWeight: 500, mb: 2 }}>Monetization Funnel</Typography>
          {
            isLoading ?
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body1" color="text.secondary">
                  Loading...
                </Typography>
              </Box> :
              MonetizationData.map((step, index) => {
                const percentage = step?.count > 0 ? (step?.count / maxMonetization) * 100 : 0;
                return (
                  <Box key={index} mb={2}>
                    {/* Label + Number */}
                    <Box display="flex" justifyContent="space-between" mb={1}>
                      <Typography fontSize={14} color="#343A40" fontWeight={500}>
                        {step?.label}
                      </Typography>
                      <Typography fontSize={14} fontWeight={500}>
                        {step?.count?.toLocaleString()}
                      </Typography>
                    </Box>

                    {/* Progress Bar */}
                    <LinearProgress
                      variant="determinate"
                      value={percentage}
                      sx={{
                        height: 12,
                        borderRadius: 5,
                        backgroundColor: "#eee",
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: step.bgColor,
                        },
                      }}
                    />
                  </Box>
                );
              })}
        </Box>
      </Box>
    </Box>
  )
}


const UserFunnel = () => {
  const filter = useSelector((state) => state.filter);
  const filterWithoutUTM = useMemo(() => {
    const { utm_options, ...rest } = filter;
    return rest;
  }, [JSON.stringify(filter)]);
  const [appFunnel, setAppFunnel] = useState({ activity: [], monetization: [], maxActivityCount: 0, maxMonetization: 0 })
  const [webFunnel, setWebFunnel] = useState({ activity: [], monetization: [], maxActivityCount: 0, maxMonetization: 0 })
  const [isLoading, setIsLoading] = useState(false);

  const updateFunnelData = (setFunnel, funnel, funnels, platForm) => {
    const funnelDetails = funnels?.find(ele => ele?.funnelType === "ENGAGEMENT")
    const monetizationDetails = funnels?.find(ele => ele?.funnelType === "MONETIZATION")
    const funnelActivity = { ...funnel }

    funnelActivity.activity = [
      { label: `Opened ${platForm}`, count: funnelDetails?.action?.OPEN_APP?.count ?? 0 },
      { label: "Searched Profiles", count: funnelDetails?.action?.SEARCH_PROFILES?.count ?? 0 },
      { label: "Initiated Chat", count: funnelDetails?.action?.INITIATE_CHAT?.count ?? 0 },
      { label: "Made Voice Call", count: funnelDetails?.action?.VOICE_CALL?.count ?? 0 },
      { label: "Made Video Call", count: funnelDetails?.action?.VIDEO_CALL?.count ?? 0 },
    ]

    funnelActivity.maxActivityCount = funnelDetails?.action?.OPEN_APP?.count ?? 0


    funnelActivity.monetization = [
      { label: "Total Paywall Views", count: monetizationDetails?.action?.VIEW_PAYMENTWALL?.count ?? 0, bgColor: '#8B5CF6' },
      { label: "Started Purchase", count: monetizationDetails?.action?.START_PAYMENT?.count ?? 0, bgColor: '#3B82F6' },
      { label: "Payment Success", count: monetizationDetails?.action?.PAYMENT_SUCCESS?.count ?? 0, bgColor: '#10B981' },
      { label: "Payment Failure", count: monetizationDetails?.action?.PAYMENT_FAILED?.count ?? 0, bgColor: '#EA4335' },
    ]
    funnelActivity.maxMonetization = monetizationDetails?.action?.VIEW_PAYMENTWALL?.count ?? 0


    setFunnel(funnelActivity)
  }

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const data = await fetchNYUserActivityFunnel(filter);
      updateFunnelData(setWebFunnel, webFunnel, data?.find(ele => ele?.platform === "WEB")?.funnels ?? [], "website")
      updateFunnelData(setAppFunnel, appFunnel, data?.find(ele => ele?.platform === "APP")?.funnels ?? [], "App")

    } catch (err) {
      console.error("Error while loading New York User activity funnel data", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filterWithoutUTM)]);


  return (
    <>
      {/* website funnel */}
      <ActivtiyFunnel isLoading={isLoading} funnelData={webFunnel?.activity} maxUsers={webFunnel?.maxActivityCount} platForm="Website" MonetizationData={webFunnel?.monetization} maxMonetization={webFunnel?.maxActivityCount} />
      {/* app funnel */}
      <ActivtiyFunnel isLoading={isLoading} funnelData={appFunnel?.activity} maxUsers={appFunnel?.maxActivityCount} platForm="App" MonetizationData={appFunnel?.monetization} maxMonetization={appFunnel?.maxActivityCount} />
    </>
  );
};

export default UserFunnel;
